export const Star = ({ color, size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {' '}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3.5L15 9.50031L21.0007 10L16 14L17.5 20.5L12.0003 17L6.5 20.5L8 14L3 10L9 9.50031L12 3.5Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{' '}
    </svg>
  )
}
